module.exports = __webpack_public_path__ + "static/media/BillingTest2.0998026c.png";